export function formatRadius(radius: string | string[]) {
    switch (radius) {
        case '':
        case '0':
            return 'within';

        default:
            return `within ${radius} miles of`;
    }
}
